/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateStripeSubscriptionRequest } from '../models/CreateStripeSubscriptionRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BillingService {

    /**
     * Handles various webhook events from stripe. These events are related to Rally's Billing system
     * @returns any OK
     * @throws ApiError
     */
    public static stripeWebhook(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/billing/stripe/webhook',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Creates a stripe subscription for the organization. This will create a new
     * subscription in stripe and return the subscription ID.
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static createStripeSubscription(
        requestBody?: CreateStripeSubscriptionRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/billing/stripe/createStripeSubscription',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

}
